import Button from "components/base/Button";
import Page from "components/base/Page";
import { Tag } from "components/base/base";
import { ProductImagesV2 } from "components/shared/ProductImages.js";
import { useModals } from "ModalProvider";
import moment from "moment";
import QcStatus from "pages/qc/components/QcStatus.js";
import { CHECK_STATUS } from "../utils.js";
import Issue from "./Issue";
import IssueForm from "./IssueForm";

function PoFinalQcReportPage({ report, fromUrl }) {
  const modal = useModals();

  const productName = report.product.productLine
    ? report.product.productLine.name
    : report.product.name;

  const bom =
    report.product.children && report.product.children.length > 0
      ? report.product.children
      : report.product.defaultSupplier
        ? [
            {
              id: `self-${report.product.id}`,
              product: report.product,
            },
          ]
        : [];

  function showIssueForm() {
    modal.present({
      title: "Add Issue 添加缺陷",
      children: <IssueForm reportId={report.id} hide={modal.hide} bom={bom} />,
      // center: true,
    });
  }

  function showEditIssueForm(issue) {
    modal.present({
      title: "Edit Issue 编辑缺陷",
      children: (
        <IssueForm
          reportId={report.id}
          hide={modal.hide}
          bom={bom}
          issue={issue}
        />
      ),
      // center: true,
    });
  }

  return (
    <Page
      backTo={fromUrl ?? "/qc/po-reports"}
      title={report.name}
      subtitle={`${productName} ✕ ${report.qty}`}
    >
      <div className="dark:text-gray-300 text-sm">
        <div className="flex flex-col m-4 lg:m-6 gap-4">
          <div className="flex mb-1">
            <ProductImagesV2 images={report.product.images} />
          </div>

          <div className="font-semibold text-base">
            [{report.product.number}] {report.product.name}
          </div>

          <div className="flex">
            <label className="w-24 flex-shrink-0">Supplier: </label>
            <span className="flex-1">
              {report.product.defaultSupplier?.name || "N/A"}
            </span>
          </div>

          <div className="flex">
            <label className="w-24 flex-shrink-0">Created: </label>
            <span className="flex-1">
              {report.createdAt
                ? moment(report.createdAt).format("YYYY-MM-DD HH:mm")
                : "N/A"}
            </span>
          </div>
        </div>

        <div className="my-6">
          <div className="px-4 lg:px-6 mb-2 text-gray-500">
            Quality Check 质量检验 (检验数: {report.checkQty})
          </div>
          <div className="px-4 md:p-6 bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 space-y-4">
            {report.qualityIssues.length > 0 && (
              <div>
                {report.qualityIssues.map((issue) => (
                  <Issue
                    key={issue.id}
                    issue={issue}
                    onEdit={showEditIssueForm}
                  />
                ))}
              </div>
            )}

            <Button onClick={showIssueForm}>+ Add Issue 添加缺陷</Button>
          </div>
        </div>

        <div className="my-6 bg-white dark:bg-gray-800 p-4 lg:p-6 border border-gray-200 dark:border-gray-700">
          <div className="lg:flex items-baseline">
            <div className="text-base font-bold">
              OVERALL INSPECTION CONCLUSION 最终检验结论
            </div>
            <QcStatus
              className="mt-2 lg:mt-0 lg:ml-4"
              status={report.qualityCheck}
            />
          </div>

          <div className="mt-4">
            <label>Quality Check 质检(Auto 自动计算):</label>
            <div className="flex mt-2 space-x-4">
              {CHECK_STATUS.map((i, index) => (
                <Tag
                  key={index}
                  title={i}
                  border
                  color={i === report.qualityCheck ? "sky" : null}
                  selected={i === report.qualityCheck}
                  disabled
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Page>
  );
}

export default PoFinalQcReportPage;
